import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { MaterialModule } from "../../../components/material/material.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CrearTipoValidezComponent } from "./crear-tipo-validez/crear-tipo-validez.component";
import { CrearTipoValidezDialog } from "./crear-tipo-validez/crear-tipo-validez-dialog/crear-tipo-validez-dialog.component";
import { EditarTipoValidezComponent } from "./editar-tipo-validez/editar-tipo-validez.component";
import { EditarTipoValidezDialog } from "./editar-tipo-validez/editar-tipo-validez-dialog/editar-tipo-validez-dialog.component";
import { EliminarTipoValidezComponent } from "./eliminar-tipo-validez/eliminar-tipo-validez.component";
import { EliminarTipoValidezDialog } from "./eliminar-tipo-validez/eliminar-tipo-validez-dialog/eliminar-tipo-validez-dialog.component";
import { IrTipoValidezComponent } from "./ir-tipo-validez/ir-tipo-validez.component";
import { TipoValidezComponent } from "./tipo-validez/tipo-validez.component";
import { VerTiposValidezComponent } from "./ver-tipos-validez/ver-tipos-validez.component";
import { RouterModule } from "@angular/router";
import { TipoValidezService } from "../../../providers/tipo-validez.service";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
    ],
    declarations: [
        CrearTipoValidezComponent,
        CrearTipoValidezDialog,
        EditarTipoValidezComponent,
        EditarTipoValidezDialog,
        EliminarTipoValidezComponent,
        EliminarTipoValidezDialog,
        IrTipoValidezComponent,
        TipoValidezComponent,
        VerTiposValidezComponent,
    ],
    entryComponents: [
        CrearTipoValidezDialog,
        EditarTipoValidezDialog,
        EliminarTipoValidezDialog,
    ],
    exports: [
        CrearTipoValidezComponent,
        EditarTipoValidezComponent,
        EliminarTipoValidezComponent,
        IrTipoValidezComponent,
        TipoValidezComponent,
        VerTiposValidezComponent,
    ],
    providers: [
        TipoValidezService
    ]
})
export class TipoValidezModule { }